const PhoneRoundedIcon = props => {
	const { color = '#ff69b4' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='15px'
			height='1em'
			viewBox='0 0 16 16'
			{...props}
		>
			{/* Background circle */}
			<rect x='2' y='0' width='12' height='20' rx='2' fill={color} />
			{/* Rectangle */}
			<rect x='3.5' y='1.5' width='9' height='12' rx='1' fill='#FFF' />
			{/* Dot at the footer */}
			<circle cx='8' cy='11' r='1' fill={color} />
		</svg>
	)
}

export default PhoneRoundedIcon
